import { render, staticRenderFns } from "./PasswordCheck.vue?vue&type=template&id=0ef218e0"
import script from "./PasswordCheck.ts?vue&type=script&lang=ts&external"
export * from "./PasswordCheck.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports